import { render } from "./CallAction.vue?vue&type=template&id=4c2c6844&scoped=true"
import script from "./CallAction.vue?vue&type=script&lang=js"
export * from "./CallAction.vue?vue&type=script&lang=js"

import "./CallAction.vue?vue&type=style&index=0&id=4c2c6844&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2c6844"]])

export default __exports__